import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { REGULAR, ULTRA_LIGHT, MONO, TABLET } from '@streamr/streamr-layout/styled'
import formatMoney from '~utils/formatMoney'

const Name = styled.div`
    font-family: ${MONO};
    font-size: 0.875rem;
    font-weight: ${REGULAR};
    letter-spacing: 1.5px;
    text-transform: uppercase;
    text-align: center;
    color: #ADADAD;

    @media (min-width: ${TABLET}px) {
        text-align: left;
    }
`

const Value = styled.div`
    font-size: 2rem;
    font-weight: ${ULTRA_LIGHT};
    line-height: 1em;
    margin-top: 1rem;
    text-align: center;
    color: #0C009A;
    letter-spacing: -0.5px;

    @media (min-width: ${TABLET}px) {
        font-weight: ${REGULAR};
        text-align: left;
        font-size: 1.5rem;
        margin-top: 0.75rem;
    }
`

const UnstyledAmountDisplay = forwardRef(({ name, value, ...props }, ref) => (
    <div {...props} ref={ref}>
        <Name>
            {name}
        </Name>
        <Value>
            {formatMoney(value).replace(/\s+/g, ',')}
        </Value>
    </div>
))

const AmountDisplay = styled(UnstyledAmountDisplay)`
    & + & {
        margin-top: 3.75rem;
    }

    @media (min-width: ${TABLET}px) {
        & + & {
            margin-top: 2rem;
        }
    }
`

export default AmountDisplay
